<template>
    <div class="home">
        <p>
            test
        </p>
    </div>
</template>
<style scoped lang="less">
@import url('../styles/text.less');
</style>
<script>
import api from '@/services/api'

export default {
    async beforeCreate() {
        const dec2hex = dec => ('0' + dec.toString(16)).substr(-2)

        const generateId = len => {
            const arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, dec2hex).join('')
        }
        if (!this.$route.params.accessToken) {
            console.log(this.$route.params)
            return
        }
        api.accessToken.next(this.$route.params.accessToken)
        const user = {
            mail: generateId(20) + '@partner.sexiertogether.com',
            password: generateId(20),
        }
        await api.request('PATCH', 'users/me', {
            isPublic: false,
            email: user.mail,
            password: user.password,
        })
        await api.login(user.mail, user.password)
        this.$router.push({
            path: '/rate',
        })
    },
}
</script>
